import type { PlatformDriver } from './platform.interface';
import type { PlatformWidgetSettings } from './platform-widget-settings.interface';

export function registerPlatformDriver(
  createWidget: (
    element: HTMLElement,
    settings: PlatformWidgetSettings
  ) => void,
  alias: string
) {
  if (!window.eapps) {
    return;
  }

  window.eapps.apps.register(
    alias,
    class Driver implements PlatformDriver {
      whenReady = (cb: any) => cb();
      initWidget = (element: HTMLElement, settings: PlatformWidgetSettings) =>
        createWidget(element, settings);
    }
  );
}
